<!-- biome-ignore-all lint/a11y/noStaticElementInteractions: no handler; the bare .stop modifier only keeps row clicks from firing behind the actions -->
<!-- biome-ignore-all lint/a11y/useKeyWithClickEvents: no action is triggered, so there is nothing to bind to a key -->
<script setup lang="ts">
  import {
    Button,
    ButtonVariant,
    Dropdown,
    DropdownItem,
  } from '@tundr/ds-components';
  import { useLocale } from '@tundr/i18n';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { computed } from 'vue';
  import { tableActionsWrapperClass } from './TableIconActions.css.ts';
  import TableActionIcon from './TableActionIcon/TableActionIcon.vue';
  import type { TableActionIconProps } from './TableActionIcon';

  const { t } = useLocale('table');

  const MAX_INLINE_ACTIONS = 1;

  const props = defineProps<{
    actions: TableActionIconProps[];
  }>();

  const isCollapsed = computed(() => props.actions.length > MAX_INLINE_ACTIONS);
</script>

<template>
  <div :class="tableActionsWrapperClass" @click.stop>
    <Dropdown v-if="isCollapsed">
      <template #trigger>
        <Button
          :variant="ButtonVariant.Icon"
          is-ghost
          :icon-name="TUNDR_ICONS.OPTIONS"
          :aria-label="t('table.actions')"
        />
      </template>
      <DropdownItem
        v-for="action in actions"
        :key="action.title"
        :label="action.title"
        :disabled="action.disabled"
        :disabled-reason="action.disabledReason"
        :test-id="action.testId"
        @click="action.onClick?.()"
      />
    </Dropdown>
    <template v-else>
      <TableActionIcon
        v-for="action in actions"
        :key="action.title"
        v-bind="action"
        @click="action.onClick"
      />
    </template>
  </div>
</template>
